import { BehaviorSubject } from '../../core/observer/BehaviorSubject';
import { GAME_MODE } from '../../stateManagment/gameState';
import { GAME_MODES } from '../../core/constats';

const min = 0;
const max = 100;

const mobileLoadingStage = (function* () {
  yield min;
  yield 15;
  yield 25;
  yield 40;
  yield 54;
  yield 67;
  yield 85;
  yield 90;
  yield max;
})();

const desktopLoadingStage = (function* () {
  yield min;
  yield 15;
  yield 25;
  yield 40;
  yield 54;
  yield 67;
  yield 85;
  yield 90;
  yield max;
})();
const loadingStage = GAME_MODE.getValue() === GAME_MODES.DESKTOP ? desktopLoadingStage : mobileLoadingStage;
const initialValue = loadingStage.next().value;

class LoadingStageService {
  stage = new BehaviorSubject(initialValue);
  max = max;
  min = min;
  next = () => {
    const { value, done } = loadingStage.next();
    if (done) {
      const stage = this.stage.getValue();
      if (stage !== max) {
        this.stage.next(value);
      }
      return;
    }
    this.stage.next(value);
  };
}

export const loadingStageService = new LoadingStageService();
